import { Box, Card, CardContent, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '@/component/Header';
import StakeDbPoolForm from '@/component/stake-db/pool/StakeDbPoolForm';
import { createStakeDbPool } from '@/api/stake-db';
import { CreateStakeDbPoolRequest, UpdateStakeDbPoolRequest } from '@/types/stake-db';

export default function StakeDbPoolCreate() {
  const navigate = useNavigate();

  const handleSubmit = async (data: CreateStakeDbPoolRequest | UpdateStakeDbPoolRequest) => {
    try {
      const re = await createStakeDbPool(data as CreateStakeDbPoolRequest);

      if (re.status === 200 || re.status === 201) {
        toast.success(re.data.message || 'Pool created successfully.');
        navigate('/stake-db-pool-list');
      } else {
        toast.error(re.data?.message || 'Failed to create pool.');
      }
    } catch (error) {
      console.error('Create pool error:', error);
      toast.error('Failed to create pool.');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title="Create Stake-db Pool" />
        <Divider />
        <CardContent
          sx={{
            maxHeight: '80vh',
            overflow: 'auto',
          }}
        >
          <StakeDbPoolForm mode="create" onSubmit={handleSubmit} />
        </CardContent>
      </Card>
    </Box>
  );
}
